module.exports = __webpack_public_path__ + "media/packs/site/assets/images/completed-9d740d8d7be41b12a7c6b288f6d47816.png";